const apps = (state) => {
  let result = state.apps && Object.keys(state.apps).length > 0 ? Object.values(state.apps) : []
  return result.sort(function (a, b) {
    if (a.avgRating < b.avgRating) {
      return -1
    }
    if (a.avgRating > b.avgRating) {
      return 1
    }
    return 0
  })
}

const originationCountries = (state) => {
  let result = state.originationCountries && Object.keys(state.originationCountries).length > 0 ? Object.values(state.originationCountries) : []
  return result
}

const countries = (state) => {
  let result = state.countries && Object.keys(state.countries).length > 0 ? Object.values(state.countries) : []
  return result
}

const callingCorridors = (state) => {
  let result = state.callingCorridors && Object.keys(state.callingCorridors).length > 0 ? Object.values(state.callingCorridors) : []
  return result
}

export default {
  apps,
  originationCountries,
  countries,
  callingCorridors
}



// WEBPACK FOOTER //
// ./src/store/modules/competitor/getters.js